/**
 * i18n Module
 *
 * Centralized translations for StudyJoyful Web and App.
 * English only (Singapore market).
 */

import en from './locales/en';

// All available namespaces
export const namespaces = [
  'common',
  'auth',
  'chat',
  'tasks',
  'learning',
  'profile',
  'errors',
  'sidebar',
] as const;

export type Namespace = (typeof namespaces)[number];

// Resources object for i18next
export const resources = {
  en,
} as const;

// Default namespace
export const defaultNS = 'common';

// Default language
export const defaultLanguage = 'en';

// Re-export locale content
export { en };

